export const appZIndex = {
  modal: 999999,
  tooltip: 1000000,
  drawer: 999998,
  notification: 1000001,
};

export const contactDetails = {
  name: "Fola Ogunde",
  // Brand
  companyName: "SupaRecords Technologies",
  siteName: "SupaRecords",
  slogan: "Manage Smarter. Grow Faster.",

  // Contact
  phoneNumberContact: "+234 807 338 8263",
  whatsAppContact: "2348073388263",
  emailAddress: "info@suparecords.ng",
  supportEmail: "support@suparecords.ng",
  salesEmail: "sales@suparecords.ng",

  // WhatsApp
  whatAppLeadingMessage:
    "Hello%20SupaRecords%20Team,%20I%20would%20like%20to%20learn%20more%20about%20your%20Inventory%20and%20Accounting%20Software.",

  // Office
  address: "Osubi, Okpe LGA, Delta State, Nigeria",
  location: "Osubi, Delta State, Nigeria",

  // Website
  website: "https://suparecords.ng",
  appUrl: "https://admin.suparecords.ng",
  signupUrl: "https://admin.suparecords.ng/auth/signup",
  loginUrl: "https://admin.suparecords.ng/auth",

  // Socials
  facebookLink: "https://facebook.com/suparecords",
  twitterLink: "https://x.com/suparecords",
  instagramLink: "https://instagram.com/suparecords",
  linkedInLink: "https://linkedin.com/company/suparecords",
  youtubeLink: "https://youtube.com/@suparecords",

  // Business
  businessHours: "Monday - Friday: 8:00 AM - 6:00 PM",
  supportHours: "24/7 Customer Support",

  // SEO
  keywords: [
    "Inventory Management",
    "Accounting Software",
    "POS System",
    "Warehouse Management",
    "Business Management",
    "Inventory Software Nigeria",
    "Cloud Inventory",
    "Stock Management",
    "Retail POS",
    "ERP Software",
  ],
};